import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickInviteModalLoading = ({
  onClose
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      "data-test-id": "quick-invite-modal-loading",
      paddingBlockStart: "800",
      paddingBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        size: "medium"
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {})]
  });
};
export default QuickInviteModalLoading;